import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider.js";
import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import getSocialTags from "../../getSocialTags";

export const setupCustomerIdentityEvent = async () => {
  if (!window[asosGlobalNamespace].webContext) {
    return;
  }

  const { geoCountry } = window[asosGlobalNamespace].webContext.getWebContext();

  const { customer } = await sdkInstanceProvider("identity");

  let isAuthenticated = undefined,
    customerId = undefined,
    firstTimeBuyer = undefined,
    isAnonymous = true;

  try {
    isAuthenticated = await customer.isAuthenticated();

    ({ isAnonymous, customerId, firstTimeBuyer } = await customer.profile());
  } catch (_) {} // eslint-disable-line no-empty

  const socialTags = await getSocialTags({ isAnonymous, customerId });

  window[asosGlobalNamespace][siteChromeGlobalNamespace].pushToDataLayer({
    customerIdentityData: {
      isAuthenticated: Boolean(isAuthenticated),
      customerId,
      firstTimeBuyer,
      hashedEmail: socialTags?.email,
      hashedFirstName: socialTags?.firstName,
      hashedLastName: socialTags?.lastName,
      hashedPhoneNumber: socialTags?.billingTelephoneMobile,
      geoIpCountryCode: geoCountry
    }
  });
};
